const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.6464 9.35712H16.3599C16.3494 9.35712 16.3397 9.35984 16.3292 9.36022C16.309 9.36022 16.2903 9.35712 16.2686 9.35712H12.9768C12.6763 9.35804 12.3883 9.47784 12.1758 9.69037C11.9632 9.90289 11.8435 10.1909 11.8425 10.4914V11.3423C11.8435 11.6429 11.9632 11.9309 12.1758 12.1434C12.3883 12.3559 12.6763 12.4757 12.9768 12.4766H16.2686C16.2888 12.4766 16.3074 12.4766 16.3292 12.4735C16.3397 12.4735 16.3494 12.4766 16.3599 12.4766H16.6464C16.8469 12.4761 17.039 12.3963 17.1807 12.2545C17.3225 12.1128 17.4023 11.9206 17.4028 11.7202V10.1132C17.4022 9.91279 17.3223 9.72077 17.1806 9.5791C17.0388 9.43743 16.8468 9.35763 16.6464 9.35712ZM13.3854 11.4842C13.2732 11.4842 13.1635 11.451 13.0703 11.3886C12.977 11.3263 12.9043 11.2377 12.8614 11.1341C12.8185 11.0305 12.8072 10.9164 12.8291 10.8064C12.851 10.6964 12.905 10.5954 12.9843 10.516C13.0637 10.4367 13.1647 10.3827 13.2747 10.3608C13.3847 10.3389 13.4988 10.3502 13.6024 10.3931C13.7061 10.436 13.7946 10.5087 13.8569 10.602C13.9193 10.6952 13.9525 10.8049 13.9525 10.9171C13.9523 11.0674 13.8925 11.2116 13.7862 11.3179C13.6799 11.4242 13.5357 11.484 13.3854 11.4842Z",
    fill: "url(#paint0_linear_1130_29799)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23276 0.0860266C9.1573 0.0232448 9.06008 -0.00716343 8.96229 0.00142867C8.8645 0.0100208 8.77406 0.0569152 8.7107 0.131895L6.81177 2.39506L14.4114 4.43121L9.23276 0.0860266Z",
    fill: "url(#paint1_linear_1130_29799)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22868 2.46776C4.13373 2.44256 4.03268 2.45597 3.94759 2.50507C3.86251 2.55417 3.80032 2.63495 3.77463 2.72976L3.09863 5.25259H14.6216L4.22868 2.46776Z",
    fill: "url(#paint2_linear_1130_29799)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6466 4.69197V4.06573C16.6463 3.96552 16.6063 3.86949 16.5354 3.79862C16.4646 3.72776 16.3685 3.68781 16.2683 3.6875H14.6746L15.8714 4.69197H16.6466Z",
    fill: "url(#paint3_linear_1130_29799)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3139 13.2331C16.2988 13.2331 16.2836 13.2354 16.2681 13.2354H12.9767C12.4754 13.2348 11.9949 13.0354 11.6404 12.6809C11.286 12.3265 11.0866 11.8459 11.086 11.3446V10.4937C11.0866 9.99243 11.286 9.51187 11.6404 9.15741C11.9949 8.80296 12.4754 8.60356 12.9767 8.60294H16.2681C16.2836 8.60294 16.2984 8.60489 16.3139 8.60528C16.3295 8.60566 16.3443 8.60294 16.3598 8.60294H16.6463V5.82472H2.17284C2.12273 5.82462 2.07471 5.80469 2.03924 5.76929C2.00377 5.7339 1.98374 5.6859 1.98353 5.63579V5.29449C1.98353 5.28944 1.98625 5.28516 1.98664 5.27972C1.98703 5.27428 1.98394 5.26573 1.98394 5.25873C1.99728 5.12996 2.05193 5.00896 2.13972 4.91382C2.22751 4.81867 2.34372 4.75448 2.47101 4.73084L2.7505 3.6875H2.38393C1.88291 3.68894 1.40282 3.8886 1.04854 4.24288C0.694265 4.59715 0.4946 5.07724 0.493164 5.57826V14.1092C0.4946 14.6103 0.694265 15.0904 1.04854 15.4446C1.40282 15.7989 1.88291 15.9986 2.38393 16H16.2681C16.3683 15.9997 16.4643 15.9598 16.5352 15.8889C16.606 15.818 16.646 15.722 16.6463 15.6218V13.2358H16.3598C16.3443 13.235 16.3295 13.2331 16.3139 13.2331Z",
    fill: "url(#paint4_linear_1130_29799)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1130_29799",
    x1: 14.6227,
    y1: 9.35712,
    x2: 14.6227,
    y2: 12.4766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFB88D",
    style: {
      stopColor: "#CFB88D",
      stopColor: "color(display-p3 0.8118 0.7216 0.5529)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59462E",
    style: {
      stopColor: "#59462E",
      stopColor: "color(display-p3 0.3490 0.2745 0.1804)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1130_29799",
    x1: 10.6116,
    y1: 0,
    x2: 10.6116,
    y2: 4.43121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFB88D",
    style: {
      stopColor: "#CFB88D",
      stopColor: "color(display-p3 0.8118 0.7216 0.5529)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59462E",
    style: {
      stopColor: "#59462E",
      stopColor: "color(display-p3 0.3490 0.2745 0.1804)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1130_29799",
    x1: 8.86014,
    y1: 2.45532,
    x2: 8.86014,
    y2: 5.25259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFB88D",
    style: {
      stopColor: "#CFB88D",
      stopColor: "color(display-p3 0.8118 0.7216 0.5529)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59462E",
    style: {
      stopColor: "#59462E",
      stopColor: "color(display-p3 0.3490 0.2745 0.1804)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1130_29799",
    x1: 15.6606,
    y1: 3.6875,
    x2: 15.6606,
    y2: 4.69197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFB88D",
    style: {
      stopColor: "#CFB88D",
      stopColor: "color(display-p3 0.8118 0.7216 0.5529)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59462E",
    style: {
      stopColor: "#59462E",
      stopColor: "color(display-p3 0.3490 0.2745 0.1804)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1130_29799",
    x1: 8.56973,
    y1: 3.6875,
    x2: 8.56973,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFB88D",
    style: {
      stopColor: "#CFB88D",
      stopColor: "color(display-p3 0.8118 0.7216 0.5529)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59462E",
    style: {
      stopColor: "#59462E",
      stopColor: "color(display-p3 0.3490 0.2745 0.1804)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.33545c90403208425c1353bb486d0abd.svg";
export { ForwardRef as ReactComponent };